import { Component } from '@angular/core'

@Component({
    selector: 'app-twitter-link-icon',
    templateUrl: './twitter-link-icon.component.html',
    styleUrls: ['./twitter-link-icon.component.css'],
    standalone: true,
})
export class TwitterLinkIconComponent {}
